import React from 'react';
import PropTypes from 'prop-types';

import Create from 'containers/rest/Create';
import { getIdByUrl } from 'utils/tools';
import Form from '../components/Form';

const CentreServicesCreate = (props) => {
  const centreId = getIdByUrl('centres', props.location);

  const formatOnSubmit = (data) => ({
    centreId,
    ...data,
  });

  return (
    <Create
      {...props}
      resource="centreServices"
      formatOnSubmit={formatOnSubmit}
    >
      <Form />
    </Create>
  );
};

CentreServicesCreate.propTypes = {
  location: PropTypes.object,
};

export default CentreServicesCreate;
